@if (staff.length > 0) {
    <table sfTable small striped [responsive]="true" hover align="middle" style="min-width: 1000px">
        <thead sfTableColor="light">
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Username</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Admin</th>
                <th>Colour</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            @for (staff of staff; track staff) {
                <tr style="height: 60px">
                    <td>{{ staff.id }}</td>
                    <td>
                        <sf-staff-inline [staff]="staff"></sf-staff-inline>
                    </td>
                    <td>{{ staff.username }}</td>
                    <td>
                        <a href="mailto:{{ staff.emailAddress }}">{{ staff.emailAddress }}</a>
                    </td>
                    <td>
                        @if (staff.phone) {
                            <a class="d-block" href="tel:{{ staff.phone }}">{{ staff.phone }}</a>
                        }
                        @if (staff.mobile) {
                            <a class="d-block" href="tel:{{ staff.mobile }}">{{ staff.mobile }}</a>
                        }
                    </td>
                    <td>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" [checked]="staff.isAdmin" disabled />
                        </div>
                    </td>
                    <td>
                        <div style="height: 10px; width: 60px" [style.backgroundColor]="staff.colour"></div>
                    </td>
                    <td class="text-end">
                        <div class="btn-group btn-group-sm">
                            <div class="btn-group">
                                <a [routerLink]="['/staff', staff.id, 'details']" sfButton color="primary" size="sm"
                                    >View</a
                                >
                            </div>
                            <div class="btn-group" ngbDropdown>
                                <button
                                    sfButton
                                    type="button"
                                    size="sm"
                                    color="secondary"
                                    class="dropdown-toggle-split"
                                    ngbDropdownToggle></button>
                                <div class="dropdown-menu" ngbDropdownMenu>
                                    @if (staff.isLocked) {
                                        <button
                                            sfButton
                                            ngbDropdownItem
                                            tooltip="Unlock staff account"
                                            (click)="onUnlockAccount.emit(staff.id)">
                                            Unlock
                                        </button>
                                    }
                                    <button sfButton ngbDropdownItem routerLink="/diary/holiday">Book Holiday</button>
                                    <button sfButton ngbDropdownItem routerLink="/diary/absence">Record Absence</button>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            }
        </tbody>
    </table>
} @else {
    <sf-empty message="There are no staff based on the search criteria"></sf-empty>
}
